import { useLang } from "@/context/LanguageContext";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import MemoireLogo from "@/components/MemoireLogo";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#0F0F10] text-neutral-100">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-8 lg:py-28">
        <div className="grid grid-cols-1 items-center gap-12 text-center">
          <div>
            <h3 className="font-['Outfit'] text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
              {t.footer.title.split(".")[0]}
              <span className="italic font-['Playfair_Display']">.</span>
            </h3>
            <p className="mx-auto mt-4 max-w-md text-sm text-neutral-400 lg:text-base">
              {t.footer.sub}
            </p>
          </div>

          <MemoireLogo
            data-testid="footer-brand-logo"
            variant="stacked"
            gold="#C9A878"
            wordmarkColor="#C9A878"
            size={64}
            className="mx-auto"
          />
          <span className="sr-only">{t.footer.tag}</span>

          <div className="mx-auto flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm text-neutral-400">
            <a
              href="mailto:hello@memoire.id"
              data-testid="footer-mail"
              className="inline-flex items-center gap-2 hover:text-white"
            >
              <Mail className="h-4 w-4" strokeWidth={1.5} />
              hello@memoire.id
            </a>
            <a
              href="https://instagram.com/heymemoire"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-ig"
              className="inline-flex items-center gap-2 hover:text-white"
            >
              <Instagram className="h-4 w-4" strokeWidth={1.5} />
              @heymemoire
            </a>
            <a
              href="https://wa.me/6287881161127"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-wa"
              className="inline-flex items-center gap-2 hover:text-white"
            >
              <MessageCircle className="h-4 w-4" strokeWidth={1.5} />
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-[11px] uppercase tracking-[0.15em] text-neutral-500 sm:flex-row lg:px-8">
          <p>{t.footer.copyright}</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
